import React, { useRef, useState } from 'react'
import { Dropzone, FileMosaic } from '@files-ui/react';
import { Box, Text } from '@chakra-ui/react';
import CsvPreview from './CsvPreview';
import 'react-dropzone-uploader/dist/styles.css'
import { uploadCsvFile } from '../Services/api';
function CsvUploader({ channel, token, setUploadingStatus, onUpload }) {
    const [files, setFiles] = useState([]);
    const [uploadError, setUploadError] = useState('');
    const uploadRequest = useRef(0);
    const selectedFile = files[0]?.file;

    const updateFiles = async (incommingFiles) => {
        const request = ++uploadRequest.current;
        setFiles(incommingFiles);
        setUploadError('');
        onUpload(null);
        if (!incommingFiles.length) {
            setUploadingStatus(false);
            return;
        }

        setUploadingStatus(true);
        try {
            const formData = new FormData();
            incommingFiles.forEach(({ file }) => formData.append('file', file));
            const res = await uploadCsvFile(token, channel, formData);
            if (request === uploadRequest.current) onUpload(res.data);
        } catch (error) {
            if (request === uploadRequest.current) setUploadError('Could not upload this CSV. Please try again.');
        } finally {
            if (request === uploadRequest.current) setUploadingStatus(false);
        }
    };
    const removeFile = (id) => {
        uploadRequest.current += 1;
        setFiles(files.filter((x) => x.id !== id));
        setUploadingStatus(false);
        onUpload(null);
    };
    return (
        <Box>
        <Dropzone
            onChange={updateFiles}
            accept="text/csv"
            footer={true}
        >
            {files.map((file) => (
                <FileMosaic key={file.id} {...file} onDelete={removeFile} info />
            ))}
        </Dropzone>
        <CsvPreview key={files[0]?.id} source={selectedFile} />
        {uploadError && <Text mt={2} color="red.600" fontSize="sm" role="alert">{uploadError}</Text>}
        </Box>
    )
}

export default CsvUploader
